// Service
import OptionsService from '../../services/options.service';
// Reducer
import * as OptionsReducer from './options.reducers';


  // Get the list of all the dropdown options ====================================================================================================

  export const getDropDownOptions = () => async (dispatch) => {
    dispatch(OptionsReducer.setgetDropDownOptionsLoading());

    try {

      const response = await OptionsService.getDropDownOptions();

      dispatch(OptionsReducer.setgetDropDownOptionsScuccess(response.data?.data));

    } catch(error) {

      dispatch(OptionsReducer.setgetDropDownOptionsFailure(error.response?.data?.message || error.message));
    }

  }